<template>
  <footer class="footer">
    <div class="wrapper">
      <div class="column column-1">
        <router-link to="/" class="logo">
          <img src="./../assets/img/logo.svg" class="img">
        </router-link>
        <div class="desc requisites">
          {{ footerRequisites }}
        </div>
        <div class="desc requisites">
          {{ footerCopyright }}
        </div>
      </div>
      <div class="column column-2">
        <ul class="nav">
          <li class="nav__item">
            <router-link class="desc" to="/">
              <b>{{ $t('Home') }}</b>
            </router-link>
          </li>
          <li class="nav__item">
            <router-link class="desc" to="/products/all">
              <b>{{ $t('Store') }}</b>
            </router-link>
          </li>
        </ul>
      </div>
      <div v-if="textPageList && textPageList.length" class="column column-3">
        <ul class="nav">
          <li v-for="item in textPageList" :key="item.id" class="nav__item desc">
            <a v-if="item" @click="goToPage(item.id)">
              <b v-if="item.title">{{ $t(item.title) }}</b>
            </a>
          </li>
        </ul>
      </div>
      <div class="column column-4">
        <div v-if="footerSupportEmail" class="desc">
          <b>{{ $t('Support:') }}</b><br>
          {{ footerSupportEmail }}
        </div>
        <div class="list">
          <a v-for="link in socials" :key="link.image" :href="link.link" target="_blank" class="item">
            <img :src="link.img" class="img" />
          </a>
        </div>
      </div>
    </div>

    <div class="wrapper payment-methods" v-if="paymentMethodsList && paymentMethodsList.length">
      <ul class="payment-methods-list">
        <li v-for="image in allImages" :key="image" class="image-wrapper">
          <img :src="image" class="support-icon img" />
        </li>
      </ul>
    </div>
  </footer>
</template>


<script>

export default {
  name: 'FooterComponent',
  components: {

  },
  props: {
    textPageList: {
      type: Array,
      required: true
    },
    footerRequisites: {
      type: String,
      required: true
    },
    footerCopyright: {
      type: String,
      required: true
    },
    footerSupportEmail: {
      type: String,
      required: true
    },
    paymentMethods: {
      type: [Object, Array],
    }
  },
  data: function () {
    return {
      socials: [],
    }
  },
  computed: {
    paymentMethodsList() {
      if (!this.paymentMethods) return [];
      return this.paymentMethods;
    },
    allImages() {
      return this.paymentMethodsList.flatMap(this.getImages);
    }

  },
  watch: {

  },
  mounted() {
    this.getSocials();
  },
  methods: {
    getImages(method) {
      const images = [];
      if (method.code === 'card' || method.title === 'Visa/Mastercard') {
        images.push(require('@/assets/img/methods/visa.svg'), require('@/assets/img/methods/mc_symbol.svg'));
        // images.push(require('@/assets/img/methods/3ds.png'));
      } else if (method.code === 'eps' || method.title === 'EPS') {
        images.push(require('@/assets/img/methods/eps.svg'));
      } else if (method.code === 'trustly' || method.title === 'Trustly') {
        images.push(require('@/assets/img/methods/trustly.svg'));
      } else if (method.code === 'giropay' || method.title === 'GiroPay') {
        images.push(require('@/assets/img/methods/giropay.svg'));
      } else if (method.code === 'blik' || method.title === 'Blik') {
        images.push(require('@/assets/img/methods/blik.svg'));
      } else if (method.code === 'paidby' || method.title === 'Paidby') {
        images.push(require('@/assets/img/methods/paidby.svg'));
      } else if (method.code === 'klarna' || method.title === 'Klarna') {
        images.push(require('@/assets/img/methods/klarna.svg'));
      } else if (method.code === 'sofortuberweisung' || method.title === 'Sofortuberweisung') {
        images.push(require('@/assets/img/methods/sofortuber.svg'));
      } else if (method.code === 'ideal' || method.title === 'iDEAL') {
        images.push(require('@/assets/img/methods/ideal.svg'));
      } else if (method.code === 'bancontact' || method.title === 'Bancontact') {
        images.push(require('@/assets/img/methods/bancontact.svg'));
      }
      return images;
    },
    goToPage(id) {
      this.$emit('goToPage', id)
    },
    getSocials() {
      this.$http.get(process.env.VUE_APP_API + 'social-links')
        .then((res) => {
          this.socials = res.data.payload;
        })
        .catch(() => {
        });
    },
  }
}
</script>
<style scoped lang="scss">
.footer {
  padding: 64px 16px;
  background: #1E283D;
}

.footer .wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 32px;
}

.footer .wrapper .column {
  flex: 1;
}

.footer .wrapper .column-1 {
  max-width: 348px;
}

.footer .wrapper .column-2 {
  max-width: 44px;
}

.footer .wrapper .column-3 {
  max-width: 110px;
}

.footer .wrapper .column-4 {
  max-width: 186px;
}

.footer .wrapper .column .list {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.footer .wrapper .column .list .img {
  width: 24px;
}

.footer .wrapper .column .desc {
  white-space: pre-line;

  :not(:first-child) {
    margin-top: 16px;
  }
}

.footer .wrapper .column .desc.requisites {
  margin-top: 16px;
}


.footer .wrapper .column .nav__item+.nav__item {
  margin-top: 16px;
}

.footer .wrapper.payment-methods {
  margin-top: 20px;
  justify-content: flex-start;
}

.footer .payment-methods-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}

.footer .payment-methods-list img {
  max-width: 70px;
  max-height: 35px;
  display: inline-block;
  width: 100%;
}
</style>